// The access-code contract the admin API and admin UI both speak: the status the
// API derives per code (never a stored column — see accessCode.ts's deriveStatus),
// and the default lifetime the "Add code" form pre-fills and the API falls back to.
export const AccessCodeStatus = {
  Unused: "unused",
  Used: "used",
  Revoked: "revoked",
  Expired: "expired",
} as const;
export type AccessCodeStatus = (typeof AccessCodeStatus)[keyof typeof AccessCodeStatus];

export const DEFAULT_ACCESS_CODE_EXPIRY_HOURS = 72;

// How long a redeemed code keeps working to log back in, measured from
// AccessCodeRedemption.redeemedAt — independent of expiresAt, which only ever
// gates a *first* redemption. See redeemAccessCode's doc comment for why.
export const ACCESS_CODE_RELOGIN_WINDOW_DAYS = 14;

// A redeemed guest's session token travels on its own header rather than
// `Authorization`, so it can never be mistaken for a Clerk token. Both sides of the
// wire read it from here: the API's authenticateSessionToken middleware and the web
// API clients that set it.
export const ASSESSMENT_SESSION_TOKEN_HEADER = "X-Assessment-Session-Token";
